import _axios from "../../libs/axios"
import { NotificationManager } from "../../components/common/react-notifications"
export default (context) => {

  const filter = {
    fields: [
      {
        name: "type",
        value: 1,
        type: "hidden",
      }
    ]
  }

  let columns = [
    {
      Header: "",
      accessor: "img",
      type: "img"
    },
    {
      Header: "main.ID",
      accessor: "ID"
    },
    {
      Header: "main.name",
      accessor: "name"
    },
    {
      Header: "main.relationship",
      accessor: "relationship"  
    },
    {
      Header: "main.principal",
      accessor: "principal",
      isBool: true
    },
    {
      Header: "main.externalId",
      accessor: "externalId"
    }
  ]

  const dependantId = context.props?.filterBy?.dependantId
  const removeFromFamilyItem = {
    id: "remove-from-family",
    icon: "simple-icon-trash",
    name: "Remove from family",
    onClick: (row, ctx) => {
      const from = row?.ID ?? row?.id
      const to = row?.dependantId ?? dependantId
      if (!from || !to) {
        NotificationManager.error("Missing family relation ids", "Opps", 5000, null, null, "outline")
        return
      }
      ctx.props.setLoader(true)
      _axios
        .post(`admUser/deletecontact/${from}/${to}`)
        .then(r => {
          ctx.props.setLoader(false)
          NotificationManager[r.status >= 0 ? "success" : "error"](r.msg, r.status >= 0 ? "" : "Opps", 5000, null, null, "outline")
          if (r.status >= 0) ctx.getData()
        })
        .catch(() => {
          ctx.props.setLoader(false)
        })
    }
  }

  const moduleConfig = {
    config: {
      resource: "admUser",
      pageSize: 40,
      list: false,
      remapRow: (form, res, action, resUpload) => {
        form.img = form.face
        form.name = `${form.last} ${form.last2?? ''}, ${form.name}`
        if (resUpload?.url) form.img = `${resUpload.url}?date=${Date.now()}`
        return form
      }
    },

    actions: {
      create: true,
      edit: true,
      delete: false,
      export: true,
      search: {
        by: "search"
      }
    },

    extras: {
      itemsInRowsTable: dependantId ? [removeFromFamilyItem] : []
    },

    filter: filter,

    form: {
      beforeOpenModal: () => {
        return new Promise((resolve) => {
          if (localStorage.getItem("listOptions")) return resolve(true)
          context.props.setLoader(true)
          _axios.get('/general/getlists')
          .then(r => {
            if(r.status === 0) {
              context.props.setLoader(false)
              localStorage.setItem("listOptions", JSON.stringify(r.data))
              resolve(true)
            }
          })
          .catch(() => {
            context.props.setLoader(false)
            resolve(false)
          })
        })
      },
      remapOne: (r) => {
        if (r.status >= 0) {
          r.data.country = { value: r.data.country, label: r.data.country }
          r.data.state = { value: r.data.state, label: r.data.state }
          r.data.city = { value: r.data.city, label: r.data.city }
          r.data.district = { value: r.data.district, label: r.data.district }
          r.data.nationality = { value: r.data.nationality, label: r.data.nationality }
          r.data.workCountry = { value: r.data.workCountry, label: r.data.workCountry }
        }
        return r
      },
      setValuesBeforePost: (v) => {
        if (context.props?.filterBy?.dependantId) {
          v.dependantId = context.props.filterBy.dependantId
        }
        return v
      },
      fields: [
        {
          name: "dependantId",
          value: context.props?.filterBy?.dependantId || 0,
          type: "hidden",
        },
        {
          col: 12,
          name: "face",
          value: "",
          type: "dropzone",
          label: "main.photography",
          rules: 'ext:jpeg,jpg,png',
          opts: {
            path: ()=> "admUser/file",
            accept: '.jpeg,.jpg,.png',
          }
        },
        {
          col: 6,
          name: "externalId",
          value: "",
          type: "text",
          label: "main.externalId",
          rules: 'required',
          opts: {
            style: 'float-label'
          }
        },
        {
          col: 6,
          name: "inactive",
          value: false,
          type: "switch",
          label: "main.inactive"
        },
        {
          col: 6,
          name: "last",
          value: "",
          type: "text",
          label: "main.lastName",
          rules: 'required',
          opts: {
            style: 'float-label'
          }
        },
        {
          col: 6,
          name: "last2",
          value: "",
          type: "text",
          label: "main.maternalSurname",
          opts: {
            style: 'float-label'
          }
        },
        {
          col: 6,
          name: "name",
          value: "",
          type: "text",
          label: "main.name",
          rules: 'required',
          opts: {
            style: 'float-label'
          }
        },
        {
          col: 6,
          name: "documenttype",
          value: "",
          type: "select",
          label: "main.documentType",
          opts: {
            style: 'float-label',
            listInLocalStorage: {
              name: "listOptions",
              listName: "documents"
            }
          }
        },
        {
          col: 6,
          name: "documentnumber",
          value: "",
          type: "number",
          label: "main.documentNumber",
          rules: 'max:20',
          opts: {
            style: 'float-label'
          }
        },
        {
          col: 6,
          name: "birthday",
          value: "",
          type: "date",
          label: "main.birthdate",
          opts: {
            style: 'float-label'
          }
        },
        {
          col: 6,
          name: "nationality",
          value: "",
          type: "select",
          label: "main.nationality",
          rules: 'required',
          opts: {
            style: 'float-label',
            path: "/general/getcountries",
            remap: (r) => {
              r.data.Results = r.data.map(item => ({ ID: item.id, name: item.name }))
              return r
            }
          }
        },
        {
          col: 6,
          name: "rip",
          value: false,
          type: "switch",
          label: "main.died"
        },
        {
          col: 6,
          name: "gender",
          value: "",
          type: "select",
          label: "main.gender",
          rules: 'required',
          opts: {
            style: 'float-label',
            items: [
              { value: 'M', label: 'M'},
              { value: 'F', label: 'F'}
            ]
          },
          renderIf: ctx => !ctx.state.rip
        },
        {
          col: 6,
          name: "maritalstatus",
          value: "",
          type: "select",
          label: "admUser.maritalstatus",
          opts: {
            style: 'float-label',
            listInLocalStorage: {
              name: "listOptions",
              listName: "martialStatus"
            }
          },
          renderIf: ctx => !ctx.state.rip
        },
        {
          col: 6,
          name: "cel",
          value: "",
          type: "number",
          label: "main.cellPhone",
          rules: "max:13",
          opts: {
            style: 'float-label'
          },
          renderIf: ctx => !ctx.state.rip
        },
        {
          col: 6,
          name: "homephone",
          value: "",
          type: "number",
          label: "main.phone",
          rules: "max:13",
          opts: {
            style: 'float-label'
          },
          renderIf: ctx => !ctx.state.rip
        },
        {
          col: 6,
          name: "mail",
          value: "",
          type: "text",
          label: "main.email",
          rules: 'required|email',
          opts: {
            style: 'float-label'
          },
          renderIf: ctx => !ctx.state.rip
        },
        {
          col: 6,
          name: "email2",
          value: "",
          type: "text",
          label: "admUser.otherEmail",
          rules: "email",
          opts: {
            style: 'float-label'
          },
          renderIf: ctx => !ctx.state.rip
        },
        {
          col: 6,
          name: "education",
          value: "",
          type: "select",
          label: "main.education",
          opts: {
            style: 'float-label',
            listInLocalStorage: {
              name: "listOptions",
              listName: "educationLevels"
            }
          },
          renderIf: ctx => !ctx.state.rip
        },
        {
          col: 6,
          name: "religion",
          value: "",
          type: "text",
          label: "admUser.religion",
          opts: {
            style: 'float-label'
          },
          renderIf: ctx => !ctx.state.rip
        },
        {
          col: 6,
          name: "userKind",
          value: 0,
          type: "select",
          label: "main.userType",
          opts: {
            style: 'float-label',
            items: [
              { value: 0, label: "Titular / Apoderado principal" },
              { value: 1, label: "Apoderado secundario" },
              { value: 3, label: "Externo / invitado" }
            ]
          },
          renderIf: ctx => !ctx.state.rip
        },
        {
          col: 6,
          name: "notifModes",
          value: "",
          type: "text",
          label: "main.notifyVia",
          rules: 'max:50',
          opts: {
            style: 'float-label'
          },
          renderIf: ctx => !ctx.state.rip
        },
        {
          col: 12,
          name: "label1",
          value: L => `<h5>${L['main.residence']}</h5>`,
          type: "label",
          renderIf: ctx => !ctx.state.rip
        },
        {
          col: 6,
          name: "address",
          value: "",
          type: "text",
          label: "main.address",
          opts: {
            style: 'float-label'
          },
          renderIf: ctx => !ctx.state.rip
        },
        {
          col: 6,
          name: "country",
          value: "",
          type: "select",
          label: "main.country",
          opts: {
            style: 'float-label',
            path: "/general/getcountries",
            remap: (r) => {
              r.data.Results = r.data.map(item => ({ ID: item.id, name: item.name }))
              return r
            }
          },
          renderIf: ctx => !ctx.state.rip
        },
        {
          col: 6,
          name: "state",
          value: "",
          type: "select",
          label: "main.state",
          parent: "country",
          opts: {
            style: 'float-label',
            path: ctx => `/general/getstates?country=${ctx.state.country}`,
            remap: (r) => {
              const data = r.data.map(item => item = {ID: item.id, name: item.name})
              r.data.Results = data
              return r
            }
          },
          renderIf: ctx => ctx.state.country && !ctx.state.rip,
        },
        {
          col: 6,
          name: "city",
          value: "",
          type: "select",
          label: "main.city",
          parent: "state",
          opts: {
            style: 'float-label',
            path: ctx => `/general/getcities?country=${ctx.state.country}&state=${ctx.state.state}`,
            remap: (r) => {
              const data = r.data.map(item => item = {ID: item.id, name: item.name})
              r.data.Results = data
              return r
            }
          },
          renderIf: ctx => ctx.state.state && !ctx.state.rip
        },
        {
          col: 6,
          name: "district",
          value: "",
          type: "select",
          label: "main.district",
          parent: "city",
          opts: {
            style: 'float-label',
            path: ctx => `/general/getdistricts?country=${ctx.state.country}&state=${ctx.state.state}&city=${ctx.state.city}`,
            remap: (r) => {
              const data = r.data.map(item => item = {ID: item.id, name: item.name})
              r.data.Results = data
              return r
            }
          },
          renderIf: ctx => ctx.state.city && !ctx.state.rip
        },
        {
          col: 12,
          name: "label2",
          value: L => `<h5>${L[`admUser.employmentData`]}</h5>`,
          type: "label",
          renderIf: ctx => !ctx.state.rip
        },
        {
          col: 6,
          name: "work",
          value: "",
          type: "text",
          label: "admUser.workplace",
          opts: {
            style: 'float-label'
          },
          renderIf: ctx => !ctx.state.rip
        },
        {
          col: 6,
          name: "jobrole",
          value: "",
          type: "text",
          label: "admUser.position",
          opts: {
            style: 'float-label'
          },
          renderIf: ctx => !ctx.state.rip
        },
        {
          col: 6,
          name: "profession",
          value: "",
          type: "select",
          label: "admUser.profession",
          opts: {
            style: 'float-label',
            listInLocalStorage: {
              name: "listOptions",
              listName: "profession"
            }
          },
          renderIf: ctx => !ctx.state.rip
        },
        {
          col: 6,
          name: "occupation",
          value: "",
          type: "select",
          label: "admUser.occupation",
          opts: {
            style: 'float-label',
            listInLocalStorage: {
              name: "listOptions",
              listName: "ocupations"
            }
          },
          renderIf: ctx => !ctx.state.rip
        },
        {
          col: 6,
          name: "workAddress",
          value: "",
          type: "text",
          label: "main.address",
          opts: {
            style: 'float-label'
          },
          renderIf: ctx => !ctx.state.rip
        },
        {
          col: 6,
          name: "workCountry",
          value: "",
          type: "select",
          label: "admUser.workCountry",
          opts: {
            style: 'float-label',
            path: "/general/getcountries",
            remap: (r) => {
              r.data.Results = r.data.map(item => ({ ID: item.id, name: item.name }))
              return r
            }
          },
          renderIf: ctx => !ctx.state.rip
        },
        {
          col: 6,
          name: "workphone",
          value: "",
          type: "number",
          label: "admUser.workPhone",
          rules: "max:13",
          opts: {
            style: 'float-label'
          },
          renderIf: ctx => !ctx.state.rip
        }
      ]
    },

    columns: columns
  }
  return moduleConfig
}